import { render, staticRenderFns } from "./singleAdmin.vue?vue&type=template&id=0f220526&scoped=true&"
import script from "./singleAdmin.vue?vue&type=script&lang=js&"
export * from "./singleAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f220526",
  null
  
)

export default component.exports